import React from "react";
import { AnimatePresence, motion } from "framer-motion";

import { TooltipDirection, TooltipProps } from "./Tooltip.types";

import "./Tooltip.scss";

const Tooltip: React.FC<TooltipProps> = ({
  show,
  close,
  children,
  content,
  direction,
  offsetHorizontal,
  offsetVertical,
}) => {
  // top
  let startY = "calc(-100% - 2.5em)";
  let endY = "calc(-100% - 3.5em)";

  let startX = `calc(-50% - ${offsetHorizontal || 0}px)`;
  let endX = `calc(-50% - ${offsetHorizontal || 0}px)`;

  if (direction === TooltipDirection.bottom) {
    startY = "0em";
    endY = "1em";
  }

  if (direction === TooltipDirection.left) {
    startY = `calc(-50% - 1.5em)`;
    endY = `calc(-50% - 1.5em)`;

    startX = "calc(-100% - 0em)";
    endX = "calc(-100% - 2.5em)";
  }

  if (direction === TooltipDirection.right) {
    startY = `calc(-50% - 1em)`;
    endY = `calc(-50% - 1em)`;

    startX = "-10px";
    endX = "0";
  }

  // bottom (default)
  let initial = {
    opacity: 0,
    y: startY,
    x: startX,
  };

  let animate = {
    opacity: 1.0,
    y: endY,
    x: endX,
    transition: {
      delay: 0.15,
    },
  };

  return (
    <div data-testid="tooltip-container" className="mp-organisms-tooltip--main">
      <div>{children}</div>
      <AnimatePresence>
        {show && (
          <>
            <motion.div
              className={`tip`}
              initial={initial}
              animate={animate}
              exit={initial}
            >
              <div
                className={`arrow ${direction || "top"}`}
                style={{ left: `calc(50% + ${offsetHorizontal || 0}px)` }}
              />

              <div data-testid="tooltip-content" className="content">
                {content}
              </div>
            </motion.div>
            <motion.div
              className="tooltip-background"
              onClick={() => close()}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, transition: { delay: 0.25 } }}
            />
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Tooltip;

// see: https://paladini.dev/posts/how-to-make-an-extremely-reusable-tooltip-component-with-react--and-nothing-else/

// return (
//   <>
//     {show && (
//       <AnimatePresence>
//         <div data-testid="Tooltip" className="mp-organisms-tooltip--main">
//           <div
//             className="content"
//             style={{ transform: `translate(${x}px, ${y}px)` }}
//           >
//             <div> {children}</div>
//           </div>
//           <div className="background" onClick={() => setShow(false)} />
//         </div>
//       </AnimatePresence>
//     )}
//   </>
// );
